var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.path != '/login' && _vm.$route.path != '/' && _vm.$route.path != '/forgetPsd')?_c('Header'):_vm._e(),(_vm.$route.path == '/login' || _vm.$route.path == '/' || _vm.$route.path == '/forgetPsd')?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }